import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetTitle,
} from "@/components/ui/sheet";
import {
  LANDING_COLORS,
  LANDING_SUPPORT,
  LANDING_SUPPORT_SHEET_TYPOGRAPHY,
} from "../constants/landing.constants";
import LandingIcon from "./LandingIcon";

interface SupportSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export default function SupportSheet({ open, onOpenChange }: SupportSheetProps) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="bottom"
        className="gap-0 rounded-t-[18px] border-0 bg-white p-0 shadow-lg"
        closeClassName="hidden"
        onOpenAutoFocus={(event) => event.preventDefault()}
      >
        <div className="flex flex-col px-4 pb-[30px] pt-2">
          <div className="flex flex-col items-center gap-2 py-2">
            <div
              className="h-1 w-8 shrink-0 rounded-full"
              style={{ backgroundColor: "#79747E" }}
              aria-hidden
            />
            <div className="flex w-full items-center justify-between gap-2">
              <SheetTitle className={LANDING_SUPPORT_SHEET_TYPOGRAPHY.title}>
                Support
              </SheetTitle>
              <SheetClose className="rounded-sm opacity-70 transition-opacity hover:opacity-100 focus:outline-none focus:ring-0 focus:ring-offset-0 focus-visible:ring-0 focus-visible:ring-offset-0">
                <LandingIcon name="x" className="h-5 w-5 shrink-0" />
                <span className="sr-only">Close</span>
              </SheetClose>
            </div>
          </div>

          <div
            className="mt-[19px] flex items-center gap-[10px] rounded-[20px] px-3 py-2.5"
            style={{ backgroundColor: LANDING_COLORS.supportBg }}
          >
            <LandingIcon name="headset" className="h-[30px] w-[30px] shrink-0" />
            <div className="min-w-0">
              <p className={LANDING_SUPPORT_SHEET_TYPOGRAPHY.supportLine1}>
                Support:{" "}
                <a
                  href={`tel:${LANDING_SUPPORT.phoneTel}`}
                  className="hover:text-landing-button"
                >
                  {LANDING_SUPPORT.phone}
                </a>
              </p>
              <p className={LANDING_SUPPORT_SHEET_TYPOGRAPHY.supportLine2}>
                {LANDING_SUPPORT.hours}
              </p>
            </div>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
